import React from 'react'
import { CircularProgressbar } from 'react-circular-progressbar'
import { BsArrowUp } from 'react-icons/bs'
import './Boardcard.css'

const Boardcard = ({val, name, maxV, minV}) => {
    const percentage = val
  return (
    <div className='boardcard-container'>
        <div className='bcrd-left-container'>
            <CircularProgressbar 
                value={percentage}  
                // text={`${percentage}%`} 
                maxValue= {maxV}
                minValue= {minV}
                circleRatio={1} 
                strokeWidth={12}
                styles={{
                    path: {
                        stroke: `rgba(255, 92, 0, ${(percentage/maxV)})`,
                        strokeLinecap: "butt",
                        transition: 'stroke-dashoffset 0.5s ease 0s',
                        transform: 'rotate(0.0turn)',
                        transformOrigin: 'center center',
                    },
                    trail: {
                        // stroke: "white",
                        stroke: '#d5d5d5',
                        strokeLinecap: "butt",
                        transform: 'rotate(0.00turn)',
                        transformOrigin: 'center center',
                    }, 
                    text: {
                        fill: "#828181",
                        fontSize: '12px',
                        fontWeight: '500',
                        fontFamily: 'Fira Sans Condensed, sans-serif'
                    },
                    background: {
                        fill: '#3e98c7',
                    }
                }}
            />
            <BsArrowUp id='id-arrowid' style={{transform: `rotate(${(percentage/maxV)*360}deg)`}}/>
        </div>
        <div className='bcrd-right-container'>
            <span>{val}</span>
            <span>{name}</span>
        </div>
    </div>
  )
}

export default Boardcard